import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { Form, Formik } from 'formik'
import { database, databaseRef } from 'utils/firebase'
import { push, update } from 'firebase/database'
import { useAlert } from 'react-alert'
import { useEffect, useState, useRef } from 'react'
import styles from '../../../styles.module.scss'
import CustomInput from 'components/CustomInputs/CustomInput'
import CustomTextArea from 'components/CustomInputs/CustomTextArea'
import { imagingSchemaTemplate } from 'validationSchema'
import { useSelector } from 'react-redux'
import { addDoctorLog } from 'utils/functions'

const AddModal = ({ isOpen, closeModal, edit, editKey, templates }) => {
  const alert = useAlert()
  const formikRef = useRef()
  const { me } = useSelector((state) => state.app)
  

  const [searchValue, setSearchValue] = useState('')
  const [initialValues, setInitialValues] = useState({
    name: '',
    procedure: '',
    reason: '',
  })

  const radioOptions = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' },
  ]

  useEffect(() => {
    if (edit && editKey && templates) {
      const selectedTemplate = templates[editKey]
      if (selectedTemplate) {
        setInitialValues({
          ...selectedTemplate.data,
          name: selectedTemplate.name,
        })
      }
    } else {
      setInitialValues({
        name: '',
        procedure: '',
        reason: '',
      })
    }
  }, [edit, editKey, templates])

  const handleSubmit = async (values, action) => {
    action.resetForm({ dirtyFields: {} })

    console.log('values', values)

    const formattedValues = {
      ...values,
    }

    const updates = {}
    try {
      if (edit && editKey) {
        updates[`templates/imaging/${editKey}/data`] = formattedValues
        updates[`templates/imaging/${editKey}/name`] = formattedValues?.name
        
        await update(databaseRef(database), updates)
        
        addDoctorLog({
          action: 'UPDATE_IMAGING_TEMPLATE',
          category: 'template',
          doctorID: me.id,
          description: `Updated imaging template: ${formattedValues.name}`,
          details: {
            templateId: editKey,
            templateName: formattedValues.name,
            procedure: formattedValues.procedure,
            reason: formattedValues.reason,
            timestamp: Date.now()
          }
        })
      } else {
        console.log('in else', formattedValues)
        const imgRef = databaseRef(database, 'templates/imaging')
        const newRef = push(imgRef)
        const imgKey = newRef.key
        
        updates[`templates/imaging/${imgKey}/data`] = formattedValues
        updates[`templates/imaging/${imgKey}/name`] = formattedValues?.name
        
        await update(databaseRef(database), updates)
        
        addDoctorLog({
          action: 'CREATE_IMAGING_TEMPLATE',
          category: 'template',
          doctorID: me.id,
          description: `Created new imaging template: ${formattedValues.name}`,
          details: {
            templateId: imgKey,
            templateName: formattedValues.name,
            procedure: formattedValues.procedure,
            reason: formattedValues.reason,
            timestamp: Date.now()
          }
        })
      }

      alert.success('Data saved successfully')
      closeModal()
    } catch (error) {
      console.error('Error saving template:', error)
      alert.error('Failed to save template')
    }
  }

  const resetForm = () => {
    if (formikRef.current) {
      formikRef.current.resetForm()
      alert.success('Form cleared')
    } else {
      alert.error('Unable to reset form')
    }
  }
  const searchStringChecker = (string) => {
    if (!string) return true
    return string.toLowerCase().includes(searchValue.toLowerCase())
  }

  return (
    <Modal isOpen={isOpen} centered size="lg">
      <ModalHeader toggle={closeModal}>
        <span className={styles.title}>
          {edit ? 'Edit Imaging' : 'New Imaging'}
        </span>
      </ModalHeader>
      <ModalBody>
        <div>
          <div
            className="d-flex justify-content-between"
            style={{ marginBottom: '1rem' }}
          >
            <span>Imaging:</span>
            {!edit && (
              <button
                className={styles.clearbtn}
                onClick={resetForm}
                type="button"
              >
                Clear form
              </button>
            )}
          </div>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={imagingSchemaTemplate}
            innerRef={formikRef}
          >
            {(FormikProps) => (
              <Form className={styles.imagingForm}>
                <div className="mb-4">
                  <CustomInput
                    name="name"
                    label="Template Name"
                    placeholder="Enter name"
                  />
                </div>
                {searchStringChecker('Imaging Procedure') && (
                  <div>
                    <span>
                      Imaging Procedure Required (X-ray, ultrasound, etc.).
                    </span>
                    <br />
                    <span className={styles.light}>
                      Please use the above guidance. Please answer all the
                      question below this one if you are submitting a request
                      for Radiology Investigation
                    </span>
                    <CustomTextArea name="procedure" />
                  </div>
                )}

                {searchStringChecker('Reason for Requisition') && (
                  <div className="w-50">
                    <CustomInput
                      name="reason"
                      label="Reason for Requisition :"
                    />
                  </div>
                )}

                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    className={styles.SaveBtn}
                    disabled={FormikProps.isSubmitting}
                  >
                    Save
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default AddModal
